import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1edafc36"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["type", "disabled", "placeholder", "readonly"];
import { computed, toRefs } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        reference: { default: '' },
        placeholder: { default: '' },
        readonly: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        isPassword: { type: Boolean, default: false }
    },
    emits: ["update:reference"],
    setup(__props, { emit }) {
        const props = __props;
        const { reference } = toRefs(props);
        const referenceComputed = computed({
            get: () => reference.value,
            set: (value) => {
                emit('update:reference', value);
            },
        });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                type: __props.isPassword ? 'password' : 'text',
                class: _normalizeClass(["common", __props.disabled ? 'disabled' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(referenceComputed) ? (referenceComputed).value = $event : null)),
                disabled: __props.disabled,
                placeholder: props.placeholder,
                readonly: props.readonly
            }, null, 10, _hoisted_1)), [
                [_vModelDynamic, _unref(referenceComputed)]
            ]);
        };
    }
});
